import React, { PropsWithChildren } from "react";

import { useGetInitialAppData } from "../../api/InitialAppData";
import { InitialAppDataContext } from "./InitialAppDataContext";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";

const InitialAppDataProvider: React.FC<PropsWithChildren<any>> = (props) => {
	const [{ data, loading }] = useGetInitialAppData();

	return (
		<>
			<LoadingIndicator open={loading} content="Application loading" />
			{!loading && (
				<InitialAppDataContext.Provider value={data ?? {}}>{props.children}</InitialAppDataContext.Provider>
			)}
		</>
	);
};

export default InitialAppDataProvider;
